@if(loading){
  <div class="spinner-container">
    <div class="spinner"></div>
  </div>
}@else {
  <app-info-screen
  [title]="'You are one step closer to'"
  [highlightedText]="'saving a life.'"
  [description]="
    'The <strong>evaluation process</strong> is designed to:'
  "
  [listItems]="[
    'Ensure that the donor candidate is medically fit, in sound mental health, has strong social support and is not at a risk for future kidney failure that might be deemed unacceptable to the candidate and/or the transplant center.',
    'Ensure the donor candidate has all the necessary information they need.',
  ]"
  [buttonText]="'Get Started'"
  [languageLabel]="'Questionnaire language'"
  [languageHelpText]="'Choose the language you want to use for the questionnaire.'"
  [languageOptions]="languageOptions"
  [selectedLanguage]="selectedLocale"
  (languageChanged)="handleLanguageChange($event)"
  (buttonClicked)="handleButtonClick()"
  [contactLink]="'/help'"
  [steps]="[
    { label: 'Initial Questionnaire', state: 'default' },
    { label: 'Comprehensive Questionnaire', state: 'default' },
    { label: 'Living Kidney Donor Consent', state: 'default' },
    { label: 'Consultation & Evaluation', state: 'default' }
  ]"
></app-info-screen>
}

